import { provideZoneChangeDetection } from '@angular/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import de from 'dayjs/locale/de';
import { twoDigitDateParseFunction } from '@vydaps/gui-commons/date-time';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { appConfig } from './app/app.config';

dayjs.extend(customParseFormat, {
  parseTwoDigitYear: twoDigitDateParseFunction,
});
dayjs.locale(de);

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
})
  .then((applicationRef) => enableDebugTools(applicationRef.components[0]))
  .catch(console.error);
